module.exports = {"title":"Cell phones and devices"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/mobileDevice/en.json
// module id = l3Kz
// module chunks = 1